module.exports = __webpack_public_path__ + "img/chevron.b553be88.svg";